import {
  call,
  ForkEffect,
  put,
  select,
  takeEvery,
  takeLatest,
  takeLeading,
} from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { SubscriptionRepository } from "@common/domain/repositories/SubscriptionRepository";
import {
  checkSubscriptionAccountByIdAction,
  checkSubscriptionAccountByIdFailureAction,
  checkSubscriptionAccountByIdSuccessAction,
  createSubscriptionAccountFailureAction,
  createSubscriptionAccountSuccessAction,
  fetchAccountDetailsFailureAction,
  fetchAccountDetailsSuccessAction,
  fetchCatalogueFailureAction,
  fetchCatalogueSuccessAction,
  fetchInvoiceFailureAction,
  fetchInvoicePaymentsFailure,
  fetchInvoicePaymentsSuccess,
  fetchInvoiceSuccessAction,
  fetchPaymentStatusFailureAction,
  fetchPaymentStatusSuccessAction,
  fetchSubscriptionInvoicesFailureAction,
  fetchSubscriptionInvoicesSuccessAction,
  fetchUserLocationFailure,
  fetchUserLocationSuccess,
  fetchUserSubscriptionsFailureAction,
  fetchUserSubscriptionsSuccessAction,
  fetchUserSubscriptionStatusFailureAction,
  fetchUserSubscriptionStatusSuccessAction,
  IFetchPaymentStatusAction,
  IFetchSubscriptionInvoicesAction,
  IFetchUserSubscriptionsAction,
  IFetchUserSubscriptionStatusAction,
  subscriptionActions,
  updateInvoiceList,
  updateSubscriptionAccountFailureAction,
  updateSubscriptionAccountSuccessAction,
} from "./actions";
import {
  ICheckSubscriptionAccountByIdAction,
  ICreatePaymentSessionAction,
  ICreateSubscriptionAccountByIdAction,
  ICreateSubscriptionAction,
  IFetchIntentAction,
  IFetchInvoiceAction,
  IGeoLocationResponse,
  IGetInvoiceAction,
  InvoiceData,
  ISubscriptionAccount,
  IUpdatePaymentAction,
  IUpdatePaymentMethodAction,
  IUpdateSubscriptionAccountByIdAction,
  transactionData,
  IFetchGeoLocationPayload,
  ISubscriptionState,
  IFetchAccountDetailsAction,
  IFetchCatolog,
} from "./interface";
import { getTenantName } from "@utils/UpdateTenant";
import { getProductBasedInvoice } from "./utils";
import { ProductName } from "module/interfaces/formInterface";
import { IUserSubscription, IUserSubscriptionsResponse } from "../common/interface";

function* fetchCatalogueSaga(action: IFetchCatolog) {
  const productName = action.payload.productName;
  try {
    const response: AxiosResponse = yield call(
      SubscriptionRepository.fetchCatalogue,
      productName
    );
    const lastResponseIndex = Array.isArray(response) ? response.length - 1 : 0;
    yield put(fetchCatalogueSuccessAction(response?.[lastResponseIndex]));
  } catch (e) {
    yield put(fetchCatalogueFailureAction(e.message));
  }
}

function* getUserLocationSaga(_action: IFetchGeoLocationPayload) {
  try {
    const { payload } = _action;
    const state = (yield select(
      (state) => state.subscription
    )) as ISubscriptionState;
    let response;
    if (state.userLocation.geoplugin_status === 200) {
      response = state.userLocation as IGeoLocationResponse;
    } else {
      response = (yield call(
        SubscriptionRepository.getUserLocation
      )) as IGeoLocationResponse;
    }
    yield put(fetchUserLocationSuccess(response));
    payload.onSuccess && payload.onSuccess(response);
  } catch (e) {
    yield put(fetchUserLocationFailure(e.message));
    _action.payload.onFailure && _action.payload.onFailure();
  }
}

// function* checkSubscriptionAccountByIdSaga(
//   action: ICheckSubscriptionAccountByIdAction
// ) {
//   try {
//     const onSuccess = action.payload?.onSuccess;
//     const externalKey = action.payload.externalKey; //"8b732b39-2c3a-4f8f-b4ba-986b4c2cc959"; // remove this hardcoded value
//     const payload = { externalKey };
//     const response: ISubscriptionAccount = yield call(
//       SubscriptionRepository.getSubscriptionAccount,
//       payload
//     );
//     onSuccess && onSuccess(response);
//     yield put(checkSubscriptionAccountByIdSuccessAction(response));
//   } catch (e) {
//     const onFailure = action.payload?.onFailure;
//     onFailure && onFailure(e);
//     yield put(checkSubscriptionAccountByIdFailureAction(e.message));
//   }
// }

// function* createSubscriptionAccountSaga(
//   action: ICreateSubscriptionAccountByIdAction
// ) {
//   try {
//     const accountData = { ...action.payload };
//     delete accountData.onSuccess;
//     delete accountData.onFailure;
//     const response = yield call(SubscriptionRepository.createAccount, {
//       data: accountData,
//     });
//     yield put(createSubscriptionAccountSuccessAction(response?.[0]));
//     yield put(
//       checkSubscriptionAccountByIdAction({
//         externalKey: accountData?.externalKey ?? "",
//       })
//     );
//     action.payload?.onSuccess(response);
//   } catch (e) {
//     yield put(createSubscriptionAccountFailureAction(e.message));
//   }
// }

// function* updateSubscriptionAccountSaga(
//   action: IUpdateSubscriptionAccountByIdAction
// ) {
//   try {
//     const accountData = { ...action.payload };
//     delete accountData.onSuccess;
//     delete accountData.onFailure;
//     // const externalKey = accountData?.externalKey; //"8b732b39-2c3a-4f8f-b4ba-986b4c2cc959"; //accountData?.accountId;
//     const response = yield call(SubscriptionRepository.updateAccount, {
//       ...accountData,
//     });
//     yield put(updateSubscriptionAccountSuccessAction(response?.[0]));
//     action.payload?.onSuccess();
//   } catch (e) {
//     yield put(updateSubscriptionAccountFailureAction(e.message));
//   }
// }
function* fetchIntentSaga(action: IFetchIntentAction) {
  try {
    const payload = action.payload;
    const response = yield call(SubscriptionRepository.fetchPaymentIntent, {
      accountId: payload.accountId,
    });
    payload.onSuccess?.(response);
  } catch (e) {
    action.payload?.onFailure?.();
  }
}
function* createSubscriptionSaga(action: ICreateSubscriptionAction) {
  try {
    const payload = action.payload;
    const response = yield call(
      SubscriptionRepository.createSubscription,
      payload
    );
    payload?.onSuccess?.(response);
  } catch (e) {
    // yield put(updateSubscriptionAccountFailureAction(e.message));
    action.payload?.onFailure?.();
  }
}
function* createPaymentSectionSaga(action: ICreatePaymentSessionAction) {
  try {
    const payload = action.payload;
    const { accountId } = payload;
    const response = yield call(SubscriptionRepository.createPaymentSession, {
      kbAccountId: accountId,
      successUrl: `${
        window.location.origin
      }/subscription/verify/${accountId}`,
      cancelUrl: `${
        window.location.origin
      }/subscription/failure`,
    });
    action.payload?.onSuccess?.(response);
  } catch (e) {
    action.payload?.onFailure?.();
  }
}

// export function* updatePaymentMethodSaga(action: IUpdatePaymentMethodAction) {
//   try {
//     const payload = action.payload;
//     const { accountId, sessionId } = payload;
//     const response = yield call(SubscriptionRepository.updatePaymentMethod, {
//       accountId,
//       sessionId,
//     });
//     action.payload?.onSuccess?.(response);
//   } catch (e) {
//     action.payload?.onFailure?.();
//   }
// }

export function* getInvoiceSaga(action: IGetInvoiceAction) {
  try {
    const payload = action.payload;
    const state = yield select((state) => state.subscription);
    const invoiceState = (state?.invoice ?? {}) as InvoiceData;
    if (!invoiceState.invoiceId || payload.force) {
      const { accountId, productName = ProductName.forms } = payload;
      const invoicesResponse: InvoiceData[] = yield call(
        SubscriptionRepository.getAllInvoices,
        {
          accountId,
          productName: productName,
        }
      );

      yield put(updateInvoiceList(invoicesResponse));

      const updatedInvoiceData = getProductBasedInvoice(
        productName,
        invoicesResponse
      );
      const invoice =
        updatedInvoiceData.length > 1
          ? updatedInvoiceData[updatedInvoiceData.length - 1]
          : updatedInvoiceData[0];

      const response: InvoiceData = yield call(
        SubscriptionRepository.getInvoiceById,
        {
          invoiceId: invoice.invoiceId ?? "",
        }
      );
      yield put(
        fetchInvoiceSuccessAction({
          invoice: response,
        })
      );
      action.payload?.onSuccess?.(response);
    } else {
      yield put(
        fetchInvoiceSuccessAction({
          invoice: invoiceState,
        })
      );
      action.payload?.onSuccess?.(invoiceState);
    }
  } catch (e) {
    yield put(fetchInvoiceFailureAction(e.message));
    action.payload?.onFailure?.();
  }
}

export function* fetchInvoicePaymentsSaga(action: IFetchInvoiceAction) {
  try {
    const payload = action.payload;
    const { accountId } = payload;
    const response = (yield call(SubscriptionRepository.fetchInvoicePayments, {
      accountId,
    })) as transactionData[];
    yield put(fetchInvoicePaymentsSuccess(response));
    action.payload?.onSuccess?.(response);
  } catch (e) {
    yield put(fetchInvoicePaymentsFailure(e.message));
  }
}

function* updatePaymentStatusSaga(action: IUpdatePaymentAction) {
  try {
    const payload = action.payload;
    const { paymentId } = payload;
    const response = yield call(SubscriptionRepository.updatePaymentStatus, {
      paymentId,
    });
    payload?.onSuccess?.();
  } catch (e) {
    action?.payload?.onFailure?.();
  }
}

function* getUserAccountDetailsSaga(action: IFetchAccountDetailsAction) {
  try {
    const accountId = action.payload;
    const response = yield call(SubscriptionRepository.getUserAccountDetails, {
      accountId,
    });
    const activeProductName = yield select(
      (state) => state.subscription.activeProductName
    );
    for (const paymentData of response) {
      const isActiveSubscription =
        paymentData?.subscriptions[0]?.productName == activeProductName;
      if (isActiveSubscription) {
        yield put(fetchAccountDetailsSuccessAction(paymentData));
      }
    }
  } catch (e) {
    yield put(fetchAccountDetailsFailureAction(e.message));
  }
}


function* fetchUserSubscriptionsSaga(action: IFetchUserSubscriptionsAction) {
  try {
    const { userId, productName } = action.payload;
    const response = yield call(
      SubscriptionRepository.fetchUserSubscriptions,
      { userId, productName }
    );
    if (!response) {
      throw new Error('No subscription data received');
    }
    yield put(fetchUserSubscriptionsSuccessAction(response));
  } catch (e) {
    yield put(fetchUserSubscriptionsFailureAction(e.message || 'Failed to fetch subscriptions'));
  }
}


function* fetchUserSubscriptionStatusSaga(action: IFetchUserSubscriptionStatusAction) {
  try {
    const { userId, productName,status } = action.payload;
    const response = yield call(
      SubscriptionRepository.fetchUserSubscriptionStatus,
      { userId, productName,status }
    );
    if (!response) {
      throw new Error('No subscription data received');
    }
    yield put(fetchUserSubscriptionStatusSuccessAction(response));
  } catch (e) {
    yield put(fetchUserSubscriptionStatusFailureAction(e.message || 'Failed to fetch subscriptions'));
  }
}


function* fetchSubscriptionInvoicesSaga(action: IFetchSubscriptionInvoicesAction) {
  try {
    const { userId,subscriptionId } = action.payload;
    
    const response = yield call(
      SubscriptionRepository.fetchSubscriptionInvoices,
      {subscriptionId,userId }
    );
    
    if (!response) {
      throw new Error('No subscription data received');
    }
    
    yield put(fetchSubscriptionInvoicesSuccessAction(response));
    
  } catch (e) {
    console.error('Failed to fetch subscriptions:', e);
    yield put(fetchSubscriptionInvoicesFailureAction(e.message || 'Failed to fetch subscriptions'));
  }
}

function* fetchPaymentStatusSaga(action: IFetchPaymentStatusAction) {
  try {
    const {subscriptionId } = action.payload;
    
    const response = yield call(
      SubscriptionRepository.fetchPaymentStatus,
      {subscriptionId }
    );
    
    if (!response) {
      throw new Error('No subscription data received');
    }
    
    yield put(fetchPaymentStatusSuccessAction(response));
    
  } catch (e) {
    console.error('Failed to fetch subscriptions:', e);
    yield put(fetchPaymentStatusFailureAction(e.message || 'Failed to fetch subscriptions'));
  }
}

export function* watchSubscription(): Generator<ForkEffect> {
  yield takeLatest(subscriptionActions.FETCH_CATALOGUE, fetchCatalogueSaga);
  // yield takeEvery(
  //   subscriptionActions.CHECK_SUBSCRIPTION_ACCOUNT_BY_ID,
  //   checkSubscriptionAccountByIdSaga
  // );
  // yield takeLatest(
  //   subscriptionActions.CREATE_SUBSCRIPTION_ACCOUNT,
  //   createSubscriptionAccountSaga
  // );
  // yield takeLatest(
  //   subscriptionActions.UPDATE_SUBSCRIPTION_ACCOUNT,
  //   updateSubscriptionAccountSaga
  // );
  yield takeLatest(
    subscriptionActions.CREATE_SUBSCRIPTION,
    createSubscriptionSaga
  );
  yield takeLatest(
    subscriptionActions.CREATE_PAYMENT_SESSION,
    createPaymentSectionSaga
  );
  // yield takeLatest(
  //   subscriptionActions.UPDATE_PAYMENT_METHOD,
  //   updatePaymentMethodSaga
  // );
  yield takeEvery(subscriptionActions.FETCH_INVOICE, getInvoiceSaga);
  yield takeEvery(
    subscriptionActions.FETCH_INVOICE_PAYMENTS,
    fetchInvoicePaymentsSaga
  );
  yield takeLatest(subscriptionActions.FETCH_PAYMENT_INTENT, fetchIntentSaga);
  yield takeLatest(
    subscriptionActions.UPDATE_PAYMENT_STATUS,
    updatePaymentStatusSaga
  );
  yield takeLeading(
    subscriptionActions.FETCH_USER_LOCATION,
    getUserLocationSaga
  );
  yield takeLatest(
    subscriptionActions.FETCH_ACCOUNT_DETAILS,
    getUserAccountDetailsSaga
  );

  yield takeLatest<IFetchUserSubscriptionsAction>(
    subscriptionActions.FETCH_USER_SUBSCRIPTIONS,
    fetchUserSubscriptionsSaga
  );

  yield takeLatest(
    subscriptionActions.FETCH_USER_SUBSCRIPTION_STATUS,
    fetchUserSubscriptionStatusSaga
  );

  yield takeLatest(
    subscriptionActions.FETCH_SUBSCRIPTIONS_INVOICES,
    fetchSubscriptionInvoicesSaga
  );

  yield takeLatest(
    subscriptionActions.FETCH_PAYMENT_STATUS,
    fetchPaymentStatusSaga
  );
}
